import React, { FunctionComponent, useMemo, useState } from "react";
import { GameInfoProps } from "../../type";
import Utils from "../../utils";
import { NotFoundView } from "../not-found";
import { Payout, Setting } from "./type";
import HippoSplashUtils from "./utils";

export const HippoSplashSettingView: FunctionComponent<GameInfoProps> = ({
  data,
}) => {
  const { currencies = [], payouts = {}, buyFreeSpinRate } = data as Setting;

  let payoutsFlat = Object.entries(payouts)
    .map(([key, value]) => [key, Object.values(value)[0]]) 
    .reduce((acc, [key, value]) => {
      acc[key] = value as number;
      return acc;
    }, {} as Payout);
  
  console.log( "%o", payouts);

  const [showCurrency, setShowCurrency] = useState(
    Object.values(currencies)[0]?.currency ?? ""
  );
  const currencySetting = useMemo(
    () => currencies.find((s) => s.currency === showCurrency),
    [showCurrency, currencies]
  );
  const orderedPayout = useMemo(
    () => Object.entries(payoutsFlat).sort((a, b) => b[1] - a[1]),
    [payoutsFlat]
  );
  if (!currencySetting) return <NotFoundView />;
  Utils.setCurrencySymbol(currencySetting.symbol);
  return (
    <>
      <ul className="nav nav-pills mb-3">
        {Object.values(currencies).map((c) => (
          <li key={c.currency} className="nav-item">
            <button
              className={`nav-link${c.currency === showCurrency ? " active" : ""
                }`}
              onClick={() => {
                setShowCurrency(c.currency);
              }}
            >
              {c.currency}
            </button>
          </li>
        ))}
      </ul>
      <div className="table-responsive">
        <table className="table table-bordered table table-striped-columns">
          <colgroup>
            <col width={"5%"} />
            <col width={"10%"} />
            <col width={"10%"} />
            <col width={"10%"} />
            <col width={"10%"} />
            <col width={"10%"} />
            <col width={"10%"} />
            <col width={"20%"} />
          </colgroup>
          <thead>
            <tr>
              <th className="align-middle">Bet Size Rate</th>
              <th className="align-middle">Min Bet</th>
              <th className="align-middle">Max Bet</th>
              <th className="align-middle">Multiplier</th>
              <th className="align-middle">Min Payout</th>
              <th className="align-middle">Max Payout</th>
              <th className="align-middle">Max Payout with Bonus</th>
              <th className="align-middle">Chip Options</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="align-middle">20%</td>
              <td className="align-middle">
                {Utils.asCurrency(currencySetting.minBet)}
              </td>
              <td className="align-middle">
                {Utils.asCurrency(currencySetting.maxBet)}
              </td>
              <td>
                {orderedPayout.map(([symbol, payout]) => (
                  <div key={symbol} className="row">
                    <div className="col">
                      <div className="symbol">
                        {HippoSplashUtils.convertSymbol(+symbol)}
                      </div>
                    </div>
                    <div className="col d-flex align-items-center">
                      <div>{payout}</div>
                    </div>
                  </div>
                ))}
              </td>
              <td className="align-middle">
                {Utils.asCurrency(
                  currencySetting.minBet *
                  0.2 *
                  Math.min(...Object.values(payoutsFlat))
                )}
              </td>
              <td className="align-middle">
                {Utils.asCurrency(
                  currencySetting.maxBet *
                  0.2 *
                  5 *
                  Math.max(...Object.values(payoutsFlat))
                )}
              </td>
              <td className="align-middle">
                {Utils.asCurrency(
                  currencySetting.maxBet *
                  0.2 *
                  5 *
                  10 *
                  Math.max(...Object.values(payoutsFlat))
                )}
              </td>
              <td className="align-middle">
                {currencySetting.chipOptions
                  .map((c) => Utils.asCurrency(c))
                  .join(", ")}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
};
